import React, { Component } from 'react'
import BrandTableContainer  from '../../../containers/POI/Brand/BrandTable'
import { Grid } from 'semantic-ui-react'
import "react-table/react-table.css"

class Brand extends Component{
    render() {
        return (
            <Grid className="tap-content" columns={2}>
                <Grid.Column widescreen={16}>
                    <BrandTableContainer />
                </Grid.Column>
            </Grid>
        )
    }
}
export default Brand
